(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8208],{

/***/ 63594:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/csboard/library",
      function () {
        return __webpack_require__(4686);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 15187:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "P": function() { return /* binding */ downloadsAPI; }
/* harmony export */ });
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _constants_http__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(23359);
/* harmony import */ var _constants_resources__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41238);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var downloadsAPI = function() {
    var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(body) {
        var res;
        return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    _ctx.next = 2;
                    return (0,_constants_http__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(_constants_resources__WEBPACK_IMPORTED_MODULE_2__/* ["default"].DOWNLOADS */ .Z.DOWNLOADS).post(body);
                case 2:
                    res = _ctx.sent;
                    if (!(res.status === 200)) {
                        _ctx.next = 7;
                        break;
                    }
                    return _ctx.abrupt("return", res.data);
                case 7:
                    return _ctx.abrupt("return", res);
                case 8:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    }));
    return function downloadsAPI(body) {
        return _ref.apply(this, arguments);
    };
}();


/***/ }),

/***/ 96091:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19521);
/* harmony import */ var _layout_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(32511);
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  > ul {\n    @media (max-width: 991px) {\n      display: grid;\n      grid-template-columns: repeat(3, 1fr);\n      grid-column-gap: 10px;\n      grid-row-gap: 10px;\n      .submenu {\n        display: none;\n      }\n    }\n    @media (max-width: 375px) {\n      grid-template-columns: repeat(2, 1fr);\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  & a {\n    word-break: keep-all;\n    height: 100%;\n    display: flex;\n    align-items: center;\n  }\n  @media (max-width: 1200px) {\n    & a {\n      padding: 15px 10px !important;\n    }\n  }\n  @media (max-width: 991px) {\n    :last-of-type {\n      margin-bottom: 10px;\n    }\n    & a {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  @media (max-width: 991px) {\n    flex-wrap: wrap;\n    .dashboard-menu {\n      width: 100%;\n    }\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}





var MenuWrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6932e942-0"
})(_templateObject());
var Menu = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].li.withConfig */ .ZP.li.withConfig({
    componentId: "sc-6932e942-1"
})(_templateObject1());
var Wrapper = styled_components__WEBPACK_IMPORTED_MODULE_4__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6932e942-2"
})(_templateObject2());
var pathName = [
    "notice",
    "faq",
    "library",
    "contact",
    "b2b",
    "service"
];
var menuIcons = [
    "megaphone",
    "exclamation",
    "cloud-download-alt",
    "headset",
    "clipboard",
    "search", 
];
var sideMenus = [
    "\uACF5\uC9C0\uC0AC\uD56D",
    "FAQ",
    "\uC790\uB8CC \uB2E4\uC6B4\uB85C\uB4DC",
    "\uC81C\uD734 \uBB38\uC758",
    "\uD328\uD0A4\uC9D5 \uC81C\uC548\uBC1B\uAE30",
    "\uAD6C\uD574\uB4DC\uB9BD\uB2C8\uB2E4", 
];
var CSBoard = function(param) {
    var children = param.children;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var routePathName = router.pathname.split("/")[2];
    var activeIndex = pathName.indexOf(routePathName);
    var handleOnClick = function(index) {
        var url = "/csboard/".concat(pathName[index]);
        router.push(url);
    };
    var pageDesc = function(path) {
        var desc = "";
        switch(path){
            case "notice":
                desc = "\uD3EC\uC7A5\uC7AC \uD30C\uD2B8\uB108\uC0AC \uC2E0\uADDC\uC785\uC810, \uC0C1\uD488 \uC2E0\uADDC\uB4F1\uB85D \uC18C\uC2DD\uC744 \uAC00\uC7A5 \uBA3C\uC800 \uB9CC\uB098\uB294 \uACF3";
                break;
            case "library":
                desc = "\uC0C1\uD488\uC744 \uAE4A\uACE0 \uB2F4\uBC31\uD558\uAC8C \uC774\uD574\uD558\uACE0 \uC2F6\uB2E4\uBA74. \uC218\uC2DC \uC5C5\uB370\uC774\uD2B8 \uC911";
                break;
            case "contact":
                desc = "\uC785\uC810\uC2E0\uCCAD, \uB0A9\uD488, \uCF5C\uB77C\uBCF4, \uCF58\uD150\uCE20 \uC81C\uD734 \uB4F1 \uCE7C\uB81B\uC2A4\uD1A0\uC5B4\uC758 \uD30C\uD2B8\uB108\uAC00 \uB418\uC5B4\uC8FC\uC138\uC694";
                break;
            case "b2b":
                desc = "\uD3EC\uC7A5\uC7AC \uBCF8\uACA9 \uAD6C\uB9E4, \uB3C4\uC785\uD558\uAE30 \uC804\uC5D0 \uC0D8\uD50C\uBD80\uD130 \uC368\uBCF4\uC138\uC694";
                break;
            case "service":
                desc = "\uAD6C\uD574\uB4DC\uB9BD\uB2C8\uB2E4";
                break;
            default:
                break;
        }
        return desc;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layout_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        parent: "\uD648",
        sub: sideMenus[activeIndex],
        pageTitle: sideMenus[activeIndex],
        pageDesc: pageDesc(routePathName),
        pageKeyword: "\uACE0\uAC1D\uC13C\uD130, \uCE7C\uB81B\uC2A4\uD1A0\uC5B4, \uACE0\uAC1D\uBB38\uC758, FAQ, \uC790\uC8FC\uBB3B\uB294\uC9C8\uBB38, 1:1\uBB38\uC758, \uC8FC\uBB38\uBB38\uC758, \uBC30\uC1A1\uBB38\uC758, \uAD50\uD658\uBC18\uD488, \uD658\uBD88\uC808\uCC28, \uC774\uC6A9\uC548\uB0B4, \uACE0\uAC1D\uC9C0\uC6D0, \uBB38\uC758\uD558\uAE30",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "page-content mt-50 pb-50",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "container",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "row",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "col-lg-12 m-auto",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(Wrapper, {
                            className: "row",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-md-2 mb-30 dashboard-menu",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(MenuWrapper, {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("ul", {
                                            className: "nav flex-column",
                                            role: "tablist",
                                            children: sideMenus.map(function(el, i) {
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Menu, {
                                                    className: "nav-item",
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                                        className: activeIndex === i ? "nav-link active" : "nav-link",
                                                        onClick: function() {
                                                            return handleOnClick(i);
                                                        },
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: "d-flex align-items-center",
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("i", {
                                                                    className: "fi-rs-".concat(menuIcons[i], " mr-10")
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                                    className: "font-sm",
                                                                    children: el
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }, i);
                                            })
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "col-md-12 col-lg-10 pl-sm-30",
                                    style: {
                                        minHeight: "30rem"
                                    },
                                    children: children
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CSBoard);


/***/ }),

/***/ 4686:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _components_csboard_CSBoard_Layout__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96091);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);
/* harmony import */ var _api_downloads__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(15187);
/* harmony import */ var react_bootstrap__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(36968);
/* harmony import */ var _common_alert__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(55150);
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}

function _templateObject() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  margin: auto 0;\n  width: 100%;\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  grid-column-gap: 20px;\n  grid-row-gap: 20px;\n  @media (max-width: 1200px) {\n    grid-template-columns: repeat(3, 1fr);\n  }\n  @media (max-width: 767px) {\n    grid-template-columns: repeat(2, 1fr);\n  }\n  @media (max-width: 575px) {\n    grid-template-columns: repeat(1, 1fr);\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  border: 2px solid #ececec;\n  padding: 20px 10px;\n  min-height: 150px;\n  cursor: pointer;\n  .icon {\n    width: 70%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 64px;\n    margin-bottom: 20px;\n    color: gray;\n  }\n\n  :hover {\n    .icon {\n      color: #3bb77e;\n    }\n    border: 2px solid #3bb77e;\n  }\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}







var DownloadWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6e24806-0"
})(_templateObject());
var DownloadRow = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-6e24806-1"
})(_templateObject1());
var DownloadBox = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].a.withConfig */ .ZP.a.withConfig({
    componentId: "sc-6e24806-2"
})(_templateObject2());
var CSBoardLibraryPage = function() {
    var ref6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), introductions = ref6[0], setIntroductions = ref6[1]; // 전체
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), b2bProposals = ref1[0], setB2bProposals = ref1[1]; //포트폴리오&B2B제안서
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)([]), productIntroductions = ref2[0], setProductIntroductions = ref2[1]; //포장제품소개서
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false), downLoading = ref3[0], setDownLoading = ref3[1];
    var fetchIntroductions = function() {
        var _ref = _asyncToGenerator(_home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var body, res, ref, ref4, allIntroductions, b2bItems, productItems, ref5;
            return _home_caret_store_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        body = {
                            modes: "ListSet"
                        };
                        _ctx.next = 3;
                        return (0,_api_downloads__WEBPACK_IMPORTED_MODULE_4__/* .downloadsAPI */ .P)(body);
                    case 3:
                        res = _ctx.sent;
                        if (res.Code === "0000") {
                            ;
                            allIntroductions = (res === null || res === void 0 ? void 0 : (ref = res.Data) === null || ref === void 0 ? void 0 : (ref4 = ref.Data) === null || ref4 === void 0 ? void 0 : ref4.introduction) || [];
                            setIntroductions(allIntroductions);
                            b2bItems = allIntroductions.filter(function(item) {
                                return item.code === "F5999" || item.code === "F4948" || item.code === "F2412";
                            });
                            setB2bProposals(b2bItems);
                            productItems = allIntroductions.filter(function(item) {
                                return item.code !== "F5999" && item.code !== "F4948" && item.code !== "F2412";
                            });
                            setProductIntroductions(productItems);
                            setDownLoading(false);
                        } else {
                            ;
                            setIntroductions([]);
                            setB2bProposals([]);
                            setProductIntroductions([]);
                            console.error((ref5 = res.Data) === null || ref5 === void 0 ? void 0 : ref5.Msg);
                            setDownLoading(false);
                        }
                    case 5:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function fetchIntroductions() {
            return _ref.apply(this, arguments);
        };
    }();
    var downloadImgs = {
        F5999: "https://file.caretbio.com/caretbio/34fe3d6a4b4f60dd683eb8f064b80380.png",
        F4948: "https://file.caretbio.com/caretbio/392cd45612edf5d35b177ae0621dc45f.png",
        F9049: "https://file.caretbio.com/caretbio/\u110C\u1166\u1111\u116E\u11B7\u1109\u1169\u1100\u1162\u1109\u1165_\u1105\u1175\u1111\u1165\u11AF\u1111\u1173\u1111\u1162\u110F\u1175\u110C\u1175\u11BC_240325173331.png",
        F2172: "https://file.caretbio.com/caretbio/\u110C\u1166\u1111\u116E\u11B7\u1109\u1169\u1100\u1162\u1109\u1165_\u110B\u1166\u110F\u1169\u1102\u1161\u11AF\u1100\u1162\u1107\u1161\u11A8\u1109\u1173.png",
        F3385: "https://file.caretbio.com/caretbio/\u110C\u1166\u1111\u116E\u11B7\u1109\u1169\u1100\u1162\u1109\u1165_\u110F\u1161\u11AF\u1105\u1166\u11BA\u110B\u1166\u110B\u1165.png",
        F1554: "https://file.caretbio.com/caretbio/\u110C\u1166\u1111\u116E\u11B7\u1109\u1169\u1100\u1162\u1109\u1165_\u1102\u1169\u11BC\u1109\u1161\u11AB\u1106\u116E\u11AF\u1111\u1169\u110C\u1161\u11BC.png",
        F7858: "https://file.caretbio.com/caretbio/\u110C\u1166\u1111\u116E\u11B7\u1109\u1169\u1100\u1162\u1109\u1165_\u110C\u1169\u11BC\u110B\u1175\u1107\u1169\u1102\u1162\u11BC\u1107\u1161\u11A8\u1109\u1173.png",
        F9810: "https://file.caretbio.com/caretbio/\u110C\u1166\u1111\u116E\u11B7\u1109\u1169\u1100\u1162\u1109\u1165_\u1111\u1165\u11AF\u1111\u1173\u110B\u116D\u11BC\u1100\u1175.png",
        F0488: "https://file.caretbio.com/caretbio/\u110C\u1166\u1111\u116E\u11B7\u1109\u1169\u1100\u1162\u1109\u1165_\u110F\u1161\u11AF\u1105\u1161\u1107\u1161\u11A8\u1109\u1173.png",
        F2313: "https://file.caretbio.com/caretbio/\u110C\u1166\u1111\u116E\u11B7\u1109\u1169\u1100\u1162\u1109\u1165_\u1105\u1175\u1111\u1165\u11AF\u1111\u1173\u1110\u1166\u110B\u1175\u1111\u1173.png",
        F6151: "https://file.caretbio.com/caretbio/\u110C\u1166\u1111\u116E\u11B7\u1109\u1169\u1100\u1162\u1109\u1165_\u1107\u1175\u1102\u1175\u11AF\u1111\u1169\u110C\u1161\u11BC\u110C\u1162.png",
        F5177: "https://file.caretbio.com/caretbio/\u110C\u1166\u1111\u1173\u11B7\u1109\u1169\u1100\u1162\u1109\u1165_EL727 \u1107\u1175\u1102\u1175\u11AF\u1111\u1169\u110C\u1161\u11BC\u110C\u1162.png",
        F2717: "https://file.caretbio.com/caretbio/\u110C\u1166\u1111\u116E\u11B7\u1109\u1169\u1100\u1162\u1109\u1165_\u110E\u1175\u11AB\u1112\u116A\u11AB\u1100\u1167\u11BCPCM\u1107\u1169\u1102\u1162\u11BC\u1111\u1162\u11A8.png",
        F2412: "https://file.caretbio.com/caretbio/392cd45612edf5d35b177ae0621dc45f.png",
        F5193: "https://file.caretbio.com/caretbio/fe5906f5b8f42c1b7ca9546d956ac9bc.png"
    };
    (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function() {
        setDownLoading(true);
        fetchIntroductions();
    }, []);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_csboard_CSBoard_Layout__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                className: "pb-30 d-flex align-items-center justify-content-between",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                        style: {
                            borderBottom: "2px solid black",
                            width: "100%"
                        },
                        children: "\uC790\uB8CC \uB2E4\uC6B4\uB85C\uB4DC"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
                        "aria-label": "Share",
                        className: "action-btn hover-up",
                        onClick: function() {
                            return navigator.clipboard.writeText(globalThis.location.href).then(function() {
                                return (0,_common_alert__WEBPACK_IMPORTED_MODULE_5__/* .successAlert */ .Cq)("\uBCF5\uC0AC\uB418\uC5C8\uC2B5\uB2C8\uB2E4.");
                            });
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("i", {
                            className: "fi-rs-share",
                            style: {
                                fontSize: "20px"
                            }
                        })
                    })
                ]
            }),
            downLoading ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                className: "d-flex justify-content-center align-items-center h-50",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(react_bootstrap__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                        className: "mt-30 mb-30",
                        children: "\uBE44\uC988\uB2C8\uC2A4 \uC790\uB8CC\uC2E4"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DownloadWrapper, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DownloadRow, {
                            children: b2bProposals && b2bProposals.map(function(el, i) {
                                var ref;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DownloadBox, {
                                    className: "box",
                                    href: el.url,
                                    target: "_blank",
                                    download: "".concat(el.name, ".pdf"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "icon",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                src: downloadImgs[el.code],
                                                alt: (ref = downloadImgs[el.code]) === null || ref === void 0 ? void 0 : ref.split("/")[4]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h6", {
                                            className: "title",
                                            children: el.name
                                        })
                                    ]
                                }, i);
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h3", {
                        className: "mt-30 mb-30",
                        children: "\uD3EC\uC7A5 \uC81C\uD488 \uC18C\uAC1C\uC11C"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DownloadWrapper, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(DownloadRow, {
                            children: productIntroductions && productIntroductions.map(function(el, i) {
                                var ref;
                                /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(DownloadBox, {
                                    className: "box",
                                    href: el.url,
                                    target: "_blank",
                                    download: "".concat(el.name, ".pdf"),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
                                            className: "icon",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
                                                src: downloadImgs[el.code],
                                                alt: (ref = downloadImgs[el.code]) === null || ref === void 0 ? void 0 : ref.split("/")[4]
                                            })
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h6", {
                                            className: "title",
                                            children: el.name
                                        })
                                    ]
                                }, i);
                            })
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (CSBoardLibraryPage);


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [3662,9199,2511,9774,2888,179], function() { return __webpack_exec__(63594); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);